import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./instrument";
import App from "./App.tsx";
import "./index.css";
import { registerPushServiceWorker } from "./lib/browserNotifications";

if (typeof window !== "undefined") {
  const registerNotifications = () => {
    void registerPushServiceWorker();
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(registerNotifications, { timeout: 2000 });
  } else {
    window.addEventListener("load", registerNotifications, { once: true });
  }
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
